import React, { useMemo } from "react";

// Ports the prototype's format_regulatory_standards: groups question_metadatas
// by title (authority) so "FDA: 21 CFR 312.58, EMA: EMA Annex V" renders as
// two grouped lines with bolded authority names, not a flat chip soup.
const groupByAuthority = (list) => {
  const groups = new Map();
  for (const c of list) {
    const title = (c?.title ?? "").trim();
    const data = (c?.data ?? "").trim();
    if (!title || !data) continue;
    if (!groups.has(title)) groups.set(title, []);
    groups.get(title).push(data);
  }
  return Array.from(groups, ([title, items]) => ({ title, items }));
};

const QuestionCitations = ({ citations }) => {
  const grouped = useMemo(
    () => groupByAuthority(Array.isArray(citations) ? citations : []),
    [citations]
  );

  if (grouped.length === 0) return null;

  return (
    <div>
      <div className="text-[11px] uppercase tracking-wide text-gray-500 mb-1">
        Regulatory &amp; compliance standards
      </div>
      <ul className="space-y-1 text-sm text-slate-800 bg-slate-50 border border-slate-200 rounded p-2">
        {grouped.map(({ title, items }) => (
          <li key={title} className="leading-snug">
            <span className="font-semibold text-slate-900">{title}:</span>{" "}
            <span className="text-slate-700">{items.join(", ")}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default QuestionCitations;
